import { Component, OnInit, Signal } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApplicationAppEntityApplicationRead } from '../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPayment,
  selectPending
} from '../../../../../store/selectors/application.selectors';
import { loadPayments } from '../../../../../store/actions/application.actions';
import {
  ApplicationPayment, ApplicationPaymentRoadOccupation,
  CostPosition,
  RoadOccupationStage
} from '../../../../../services/application.common.model';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../../../../common/spinner/spinner.component';
import { AccordionGroupComponent } from '../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../common/accordion-item/accordion-item.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ToNumberPipe } from '../../../../../pipes/to-number.pipe';
import { StagesComponent } from '../../../../../common/stages/stages.component';

export interface PaymentsDataComponentConfig {
  stages: string[];
  successUrl: string;
  cancelUrl: string;
}

@Component({
  selector: 'app-payments-data-section',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    SpinnerComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    LabelComponent,
    ToNumberPipe,
    StagesComponent
  ],
  templateUrl: './payments-data-section.component.html'
})
export class PaymentsDataSectionComponent implements OnInit {

  public successUrl: string | undefined = this.route.snapshot.data['successUrl'];

  public cancelUrl: string | undefined = this.route.snapshot.data['cancelUrl'];

  public stages: string[] = this.route.snapshot.data['stages'];

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public payment: Signal<ApplicationPayment | null> = this.store$.selectSignal(selectPayment);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(
    private store$: Store,
    private route: ActivatedRoute
  ) {
  }

  public calcTotalStageCost(occupation: ApplicationPaymentRoadOccupation): string {
    let allCosts: number[] = [];
    occupation.stages.map(stage => this.getCostPositions(stage).map(costPosition => Number(costPosition.totalCost.replace(',', '.') || 0)).filter(c => !!c))
      .forEach(costs => {
        allCosts = allCosts.concat(costs);
      });
    let result: number = 0.00;
    allCosts.forEach(cost => {
      result = result + cost;
    });
    return result.toFixed(2);
  }

  public getCostPositions(v: RoadOccupationStage): CostPosition[] {
    return v.years[0]?.costPositions?.filter(v => !!v.area) || [];
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadPayments({ applicationId: this.applicationId || '' }));
  }
}
